const countByParent = (parents: readonly (string | undefined)[]): ReadonlyMap<string, number> => {
	const counts = new Map<string, number>()

	for (const parent of parents) {
		if (parent) counts.set(parent, (counts.get(parent) ?? 0) + 1)
	}

	return counts
}

export { countByParent }
